// Add device modal
export const sharedDeviceModel = {
  'DBG-X1000': ['DBG-X1000', 'DBG-2000(B1)']
};

const addDeviceField = {
  deviceUid: 'deviceUid',
  deviceName: 'deviceName',
  site: 'site',
  profile: 'profile',
  licenseKeyList: 'licenseKeyList'
};

export const defaultAddDeviceState = {
  [addDeviceField['deviceUid']]: {
    value: null,
    length: 12,
    list: [],
    originList: [],
    required: true,
    dirty: false,
    valid: false,
  },
  [addDeviceField['deviceName']]: {
    value: '',
    required: false,
    minLength: 1,
    maxLength: 64,
    dirty: false,
    valid: false,
  },
  [addDeviceField['site']]: {
    selected: null,
    list: [],
    originList: [],
    required: true,
    restrictCountryCode: ''
  },
  [addDeviceField['profile']]: {
    selected: null,
    list: [],
    originList: [],
    required: true
  },
  [addDeviceField['licenseKeyList']]: {
    valueList: [],
    list: [],
    defaultLicense: null,
    required: true
  }
};